export enum SpacerToBeUsed {
  PrimaryInstallationStartingSpacer = 0,
  SecondaryInstallationStartingSpacer = 1,
  PrimaryInstallationFinishingSpacer = 2,
  SecondaryInstallationFinishingSpacer = 3,
  PrimaryInstallationSpacer = 4,
  SecondaryInstallationSpacer = 5,
}
